import { ColumnDef } from '@tanstack/react-table'
import { DrilldownButton, LinkButtonReactRouter } from '~/components/button'
import { User } from '~/utils/records'

import { AnalyticsQueryFilter } from '@hap/analytics'
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@hap/components'

interface CellProps {
  width?: number
  drilldownKeys: Array<string | AnalyticsQueryFilter>
}

export function makeExploreColumnV2<D extends UnknownRecord>({
  drilldownKeys,
  width = 40,
}: CellProps): ColumnDef<D> {
  return {
    id: 'sticky',
    header: '',
    size: width,
    maxSize: width,
    enableResizing: false,
    cell: (cell) => {
      const filters = drilldownKeys
        .map((key) => {
          if (typeof key === 'string') {
            const value = (cell.row.original as Record<string, User>)[key]
            if (value) {
              const id = value?.id
              return { field: key, op: 'in', values: [id] } as AnalyticsQueryFilter
            }
          } else {
            return key as AnalyticsQueryFilter
          }
        })
        .filter((f) => f) as AnalyticsQueryFilter[]

      return filters.length ? (
        <DrilldownButton filters={filters} size="icon-sm" />
      ) : (
        <Button icon="arrow-left" disabled variant="secondary" size="icon-sm" />
      )
    },
  }
}

export function makeInteractionViewerActionCell<D extends UnknownRecord>({
  width = 40,
  fieldKey,
}: {
  fieldKey: keyof D
  width?: number
}): ColumnDef<D> {
  return {
    id: 'sticky',
    accessorKey: fieldKey,
    header: '',
    size: width,
    maxSize: width,
    enableResizing: false,
    cell: (cell) => {
      return (
        <Tooltip>
          <TooltipTrigger asChild>
            <LinkButtonReactRouter
              className="opacity-0 group-hover/row:opacity-100"
              icon="arrow-right"
              to={`/contact-logs/${cell.getValue<string>()}`}
              size="sm"
              variant="secondary"
            >
              View Interaction
            </LinkButtonReactRouter>
          </TooltipTrigger>
          <TooltipContent>View Interaction</TooltipContent>
        </Tooltip>
      )
    },
  }
}
